import { authGuard, noAuthGuard } from '@aionzdev/modules';
import { Routes } from '@angular/router';
import { companySelectionGuard } from './core/guards/company-selection.guard';
import { papelGuard } from './core/guards/papel.guard';
import { PapelEmpresa } from './core/models/papel-empresa.enum';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/login'
  },
  {
    path: 'selecionar-empresa',
    loadComponent: () =>
      import('./pages/selecionar-empresa/selecionar-empresa').then(
        c => c.SelecionarEmpresaComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'main',
    loadComponent: () => import('./layouts/main/main').then(c => c.Main),
    canActivate: [authGuard, companySelectionGuard],
    canActivateChild: [authGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'inicio' },
      { path: '', loadChildren: () => import('./pages/inicio/inicio.routes').then(m => m.INICIO_ROUTES) },
      { path: '', loadChildren: () => import('./pages/catalogos/catalogos.routes').then(m => m.CATALOGOS_ROUTES), data: { papeis: [PapelEmpresa.ADMIN, PapelEmpresa.GERENTE_COMPRAS, PapelEmpresa.COMPRADOR] }, canActivate: [papelGuard] },
      { path: '', loadChildren: () => import('./pages/purchasing-manager/purchasing-manager.admin.module').then(m => m.PurchasingManagerAdminModule), data: { papeis: [PapelEmpresa.ADMIN, PapelEmpresa.GERENTE_COMPRAS, PapelEmpresa.COMPRADOR, PapelEmpresa.APROVADOR] }, canActivate: [papelGuard] },
      { path: '', loadChildren: () => import('@aionzdev/modules').then(m => m.ChatsAdminModule), data: { papeis: [PapelEmpresa.ADMIN, PapelEmpresa.GERENTE_COMPRAS, PapelEmpresa.COMPRADOR] }, canActivate: [papelGuard] },
      { path: '', loadChildren: () => import('@aionzdev/modules').then(m => m.UserAdminModule), data: { papeis: [PapelEmpresa.ADMIN, PapelEmpresa.GERENTE_COMPRAS, PapelEmpresa.COMPRADOR] }, canActivate: [papelGuard] },
      { path: '', loadChildren: () => import('@aionzdev/modules').then(m => m.UserClientModule) },
      { path: '**', redirectTo: 'inicio' }
    ]
  },
  {
    path: '',
    loadComponent: () => import('./layouts/blank/blank').then(c => c.Blank),
    canActivate: [noAuthGuard],
    canActivateChild: [noAuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('@aionzdev/modules').then(m => m.AuthModule)
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/'
  }
];
